"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DetailsBanner;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DetailsBanner(_ref) {
  var imageUrl = _ref.imageUrl;
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    fallbackBannerImageUrl = _useConfig$widgetCust2.fallbackBannerImageUrl;
  var sourceUrl = {
    src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackBannerImageUrl
  };
  var backgroundImage = {
    sm: sourceUrl,
    md: sourceUrl,
    lg: sourceUrl,
    xl: sourceUrl
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, backgroundImage && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-details-banner"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SkinnyBanner, {
    heading: {
      text: ''
    },
    backgroundImage: backgroundImage
  })));
}
DetailsBanner.propTypes = {
  imageUrl: _propTypes.default.string
};